// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + {"33":"user-page","88":"login-page","223":"home-page","277":"notices-page","316":"register-page","371":"friends-page","921":"news-page"}[chunkId] + "." + {"33":"035b985d","88":"a01a3c7c","223":"4dc1a0f7","277":"6471679e","316":"8bce48b9","371":"dc64adcd","921":"ff0abb39"}[chunkId] + ".chunk.js";
};